import { LoadMoreKeys, useLoadMoreState } from '@lune-fe/lune-components-lib'
import { LuneThemeNew } from '@lune-fe/lune-ui-lib'
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined'
import CloudOffIcon from '@mui/icons-material/CloudOff'
import Co2Icon from '@mui/icons-material/Co2'
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined'
import { Box } from '@mui/material'
import { MAIN_NAV_LOCATION_KEY } from 'appConstants'
import { Link } from 'react-router-dom'

import AccountSwitcher from 'components/AccountSwitcher'
import Menu, { MenuItem } from 'components/navigation/Menu'
import SVGLogo from 'components/SVGLogo'
import TestModeSwitch from 'components/TestModeSwitch'
import useScrollRestoration, { ScrollPositionKeys } from 'hooks/useScrollRestoration'

const MainNavigation = () => {
    const { palette } = LuneThemeNew
    const { clearScrollSession } = useScrollRestoration()
    const { clearLastCount } = useLoadMoreState()

    return (
        <Box
            data-testid={'navigation-list'}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
                overflow: 'hidden',
                backgroundColor: palette.Surface100,
            }}
        >
            <Box
                sx={{
                    height: '100%',
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box
                    sx={{
                        py: 0,
                        px: 3,
                        mb: 2,
                        mt: 4,
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Link
                        to="/"
                        onClick={() => clearScrollSession(ScrollPositionKeys.PROJECT_BUNDLES)}
                    >
                        <SVGLogo />
                    </Link>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        p: 2,
                        flexDirection: 'column',
                        flex: '1 0 auto',
                    }}
                >
                    <AccountSwitcher />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            justifyContent: 'space-between',
                            height: '100%',
                        }}
                    >
                        <Menu>
                            <MenuItem label={'Home'} href={'/'} icon={<WidgetsOutlinedIcon />} />
                            <MenuItem
                                label={'Emissions'}
                                icon={<Co2Icon />}
                                subItems={[
                                    {
                                        label: 'Calculations',
                                        href: '/calculate-emissions',
                                        onClick: () => {
                                            clearLastCount(LoadMoreKeys.EMISSION_CALCULATION)
                                            clearScrollSession(
                                                ScrollPositionKeys.EMISSION_CALCULATION,
                                            )
                                        },
                                    },
                                    {
                                        label: 'Imports',
                                        href: '/imports',
                                        onClick: () => {
                                            // TODO @festina clear pagination state here
                                            console.log('nothing for now')
                                        },
                                    },
                                    {
                                        label: 'Emission Factors',
                                        href: '/emission-factors',
                                    },
                                ]}
                            />
                            <MenuItem
                                label={'Analytics & Reports'}
                                icon={<BarChartOutlinedIcon />}
                                subItems={[
                                    {
                                        label: 'Overview',
                                        href: '/analytics',
                                    },
                                    {
                                        label: 'Data Health',
                                        href: '/data-health',
                                    },
                                ]}
                            />
                            <MenuItem
                                label={'Emission Reduction'}
                                href={'/reduce-emissions'}
                                icon={<CloudOffIcon />}
                            />
                            <MenuItem
                                label={'Climate Projects'}
                                icon={<PublicOutlinedIcon />}
                                subItems={[
                                    {
                                        label: 'Fund Climate Projects',
                                        href: '/order',
                                    },
                                    {
                                        label: 'Projects',
                                        href: '/projects',
                                    },
                                    {
                                        label: 'Orders & Proposals',
                                        href: '/orders',
                                    },
                                ]}
                            />
                            <MenuItem
                                label={'Client accounts'}
                                href={'/client-accounts'}
                                icon={<PeopleAltOutlinedIcon />}
                            />
                        </Menu>
                        <Menu>
                            <MenuItem
                                dataTestId={`navigation-go-to-market-btn`}
                                label={'Go-to-market'}
                                href={'/go-to-market'}
                                icon={<CampaignOutlinedIcon />}
                            />
                            <MenuItem
                                dataTestId={`navigation-developers-btn`}
                                label={'Developers'}
                                href={'/developers'}
                                icon={<CodeOutlinedIcon />}
                            />
                            <MenuItem
                                dataTestId={`navigation-settings-btn`}
                                label={'Settings'}
                                href={'/settings'}
                                onClick={() => {
                                    localStorage.setItem(MAIN_NAV_LOCATION_KEY, location.pathname)
                                }}
                                icon={<SettingsOutlinedIcon />}
                            />
                        </Menu>
                    </Box>
                </Box>
            </Box>
            <TestModeSwitch />
        </Box>
    )
}

export default MainNavigation
